import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Department } from '../../models/department/department';

import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class DepartmentProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/department`;

  getAllDepartments(): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/all`);
  }

  getDepartmentById(id: string): Observable<ApiResponse<Department>> {
    return this.httpClient.get<ApiResponse<Department>>(`${this.baseUrl}/${id}`);
  }
  getDepartmentsByMember(username: string): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/search-by-member?username=${encodeURIComponent(username)}`);
  }

  getDepartmentsByManager(username: string): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/search-by-manager?username=${encodeURIComponent(username)}`);
  }
}
